export const enum TagStep {
  TagSelection,
  Processing,
  FinalNotification,
}
export const Steps: Map<TagStep, TagStep> = new Map([
  [TagStep.TagSelection, TagStep.Processing],
  [TagStep.Processing, TagStep.FinalNotification],
]);
